window.theme = theme || {};
theme.customTemplates = (function () {

  

  function initCustomEventListeners() {
    console.log('initCustomEventListeners');

    $(document).on("click", ".reorder-products-btn", function(){
      $.magnificPopup.close();
      $("body").addClass("loading");
      let order = $(this).attr("data-order");
      console.log(order);
      //iterate all checkboxs that are checked with specific name order
      let items = [];
      $("input[name='reorderChk" + order + "']:checked").each(function(){
          let variant_id = $(this).attr("data-variant-id");
          let quantity = $("#qty_" + variant_id).val();

          items.push({
              id: variant_id,
              quantity: quantity
          });
      });

      console.log("items: ");
      console.log(items);

      //add items to cart
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
              items: items
          },
          dataType: 'json',
          success: function(cart) {
              console.log("success");
              console.log(cart);

              // let event = new CustomEvent('item:added',{
              //     bubbles: true,
              //     cancelable: true
              // });
              // document.dispatchEvent(event);
              
              //close magnific popup
              $("body").removeClass("loading");
              
              //redirect to cart page
              window.location.href = "/cart";
          }
      });
    });

    $(document).on('click', '.btn-download', function () {
      let url = $(this).attr("data-url");
      let filename = $(this).attr("download");

      function download(url, filename) {
          fetch(url)
            .then(response => response.blob())
            .then(blob => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = filename;
              link.click();
          })
          .catch(console.error);
      }
      console.log("download", url);
      download(url, filename);
      
    });

    $(document).on('click', '.btn-show-variants', function () {
      var variant_row_id = $(this).attr('data-variants-row');
      $("." + variant_row_id).toggle();
    });

    $(".cart_row .qtyBtn").on("click", function () {
      var qtyField = $(this).parent(".qtyField"),
        oldValue = $(qtyField).find(".qty").val(),
        newVal = 1
      variant = $(qtyField).find(".qty").data("variant");
      ;

      if ($(this).is(".plus")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).find(".qty").val(newVal);

      if (variant) {
        console.log("variant", variant);
        $("#hidden_qty_" + variant).val(newVal);
        $("#hidden_qty_mobile_" + variant).val(newVal);
      }
    });

    //subscribe to submit button #checkout and #CartDrawer-Checkout

    $(document).on('click', '.cartCheckoutBtn222', function (event) {

      console.log('checkout clicked');
      //cancel the submit
      event.preventDefault();

      console.log("min_cart_value_first", min_cart_value_first);
      console.log("min_cart_value_second", min_cart_value_second);
      console.log("orders_count", orders_count);
      console.log("customer_tags", customer_tags);
      console.log("validar_monto", validar_monto);

      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          console.log("cart.js");
          console.log(data);

          let cart_total = data.total_price / 100;
          let cart_items = data.item_count;

          console.log("cart_total", cart_total);

          let amount_to_validate = 0;
          let first_order = false;

          if (orders_count == 0) {
            amount_to_validate = min_cart_value_first;
            first_order = true;
          } else {
            //if customer_tags no_validar_monto
            if (validar_monto == "No") {
              amount_to_validate = 0;
            } else {
              amount_to_validate = min_cart_value_second;
            }
          }

          if (cart_total < amount_to_validate) {
            let formatted_min_cart_value = amount_to_validate.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
            formatted_min_cart_value = formatted_min_cart_value.substring(0, formatted_min_cart_value.length - 3);

            let message = `Tu pedido debe ser superior a ${formatted_min_cart_value}.  Agrega más productos y continua con tu negocio`;

            if (first_order) {
                message = `Tu primer pedido debe ser superior a ${formatted_min_cart_value}, agrega más productos e incrementa tu ganancia.`;
            }

            Swal.fire({
              text: message,
              imageUrl: 'https://cdn.shopify.com/s/files/1/0590/9895/5865/files/LOGO-MAYORISTAS-min.png?v=1713329299',
              imageWidth: 100,
              imageAlt: 'Logo Mayoristas'
            });
          } else {
              //submit parent form
              console.log('submitting form');
              $(".cartCheckout").click();
          }

        });

    });

  }

  return {
    init: function () {
      initCustomEventListeners();
    }
  };
})();
theme.customTemplates.init();